/**
 * 集計ページ共通の期間ツールバー: 日次／週次／月次の切替と前後移動(⑥指示)。
 * 2026-09-18 UIデザインシステムの絞り込み行(FilterBar)と切り替え(SegmentedControl)に置き換えた(D-90)。
 */
import DateField from '@core/components/DateField';
import { dayTextClass } from '@core/lib/holidays';
import { IconChevronLeft, IconChevronRight } from '@core/components/icons';
import FilterBar from '@core/components/ui/FilterBar';
import SegmentedControl from '@core/components/ui/SegmentedControl';
import { PERIOD_LABELS, shiftAnchor, type PeriodData } from './usePeriod';

const MODE_OPTIONS = (Object.keys(PERIOD_LABELS) as (keyof typeof PERIOD_LABELS)[]).map((key) => ({ key, label: PERIOD_LABELS[key] }));

export default function PeriodToolbar({ period, right, showModes = true }: { period: PeriodData; right?: React.ReactNode; showModes?: boolean }) {
  const { mode, setMode, anchor, setAnchor, range, latest } = period;
  return (
    <FilterBar label="対象期間" actions={right}>
      {showModes && <SegmentedControl label="集計の単位" options={MODE_OPTIONS} value={mode === 'year' ? 'month' : mode} onChange={setMode} />}
      <span className="ui-date-nav">
        <button type="button" className="ui-btn ui-btn-secondary ui-btn-icon" onClick={() => setAnchor(shiftAnchor(mode, anchor, -1))} aria-label="前の期間">
          <IconChevronLeft size={16} />
        </button>
        {mode === 'year' ? (
          <input type="number" className="ui-input" aria-label="年" min={2020} max={2100} value={Number(anchor.slice(0, 4))} onChange={(e) => e.target.value && setAnchor(`${e.target.value}-01-01`)} style={{ width: 96 }} />
        ) : mode === 'month' ? (
          <input type="month" className="ui-input" aria-label="月" value={anchor.slice(0, 7)} onChange={(e) => e.target.value && setAnchor(`${e.target.value}-01`)} />
        ) : (
          <DateField variant="ui" value={anchor} onChange={setAnchor} />
        )}
        <button type="button" className="ui-btn ui-btn-secondary ui-btn-icon" onClick={() => setAnchor(shiftAnchor(mode, anchor, 1))} aria-label="次の期間">
          <IconChevronRight size={16} />
        </button>
      </span>
      <span className={`ui-period-label ${mode === 'day' ? dayTextClass(range.anchor) : ''}`}>{range.label}</span>
      {latest && (
        <span className="ui-hint">
          集計データの最新日 {latest.replaceAll('-', '/')}
          {latest !== anchor && mode === 'day' && (
            <>
              {' '}
              <button type="button" className="ui-link" onClick={() => setAnchor(latest)}>
                最新日へ
              </button>
            </>
          )}
        </span>
      )}
    </FilterBar>
  );
}
